import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import io, { Socket } from "socket.io-client";
import taskQueue from "../../utils/TaskQueue";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { useToast } from "../../controller/ToastController";
import MessageController from "../../controller/MessageController";
import { refreshOrderState, requestReviewState } from "../../recoil/socket";
import { ORDER_CANCLE_STATUS, ORDER_COM_DEL_STATUS } from "../../recoil/type";

const SocketService = React.memo((oProps: any) => {
  const showToast = useToast();
  const qrAuth = useRecoilValue<qrAuthType>(qrAuthState);

  const processMsg = async (
    oParsed: {
      user_token_id: number;
      action: string;
      url: string;
      params: any;
      send_log_id: number;
    },
    socket: Socket
  ) => {
    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData(JSON.stringify(oParsed))
    );

    try {
      console.log("enqueue", JSON.stringify(oParsed));
      if (oParsed && oParsed.action && oParsed.action === "refresh") {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData("refresh")
        );
      } else if (oParsed && oParsed.action && oParsed.action === "restart") {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData("restart")
        );
      } else if (oParsed && oParsed.action && oParsed.action === "newOrder") {
        setRecoil(refreshOrderState, {
          date: new Date().getTime(),
          order_category: oParsed.params.order_category,
          order_status: 0,
        });
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "changeOrder"
      ) {
        if (oParsed.params.order_status === ORDER_CANCLE_STATUS) {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
            cancel_description: oParsed.params.cancel_description,
          });
        } else if (oParsed.params.order_status === ORDER_COM_DEL_STATUS) {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
            pickup_name: oParsed.params.pickup_name,
            pickup_name_en: oParsed.params.pickup_name_en,
          });
        } else {
          setRecoil(refreshOrderState, {
            date: new Date().getTime(),
            order_category: oParsed.params.order_category,
            order_status: oParsed.params.order_status,
          });
        }
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "requestReview"
      ) {
        setRecoil(requestReviewState, {
          order_id: oParsed.params.order_id,
          order_seq: oParsed.params.order_seq,
          status: oParsed.params.status,
          user_token_id: oParsed.params.user_token_id,
          store_id: oParsed.params.store_id,
          parent_store_id: oParsed.params.parent_store_id,
          store_name: oParsed.params.store_name,
          product_name: oParsed.params.product_name,
          product_name_en: oParsed.params.product_name_en,
          product_name_ch: oParsed.params.product_name_ch,
          product_name_ja: oParsed.params.product_name_ja,
          product_name_th: oParsed.params.product_name_th,
          product_quantity: oParsed.params.product_quantity,
        });
      } else if (oParsed && oParsed.action && oParsed.action === "capture") {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData("capture")
        );
      }
      socket.emit("confirm", "OK");
    } catch (err) {
      console.log("!!!!!processMsg error:", err);
    }
  };

  // const [sReceivedMsg, set_sReceivedMsg] = React.useState<any>('');

  const startSocket = async () => {
    console.log("start!!!!");
    // let token = await AppConfigController.getObjectCryptoAsyncStorage('refresh-token');
    // let token = nowAuth.refreshToken;
    // let token = await RecoilAsyncStorage.getItem('refresh-token');

    let socket = io(`${process.env.REACT_APP_WEBSOCKET_URL}`, {
      transports: ["websocket", "polling"],
      autoConnect: false,
      auth: { token: getRecoil(qrAuthState).refresh_token },
      reconnection: true,
      reconnectionDelay: 500,
    });

    //auth: { token: token },

    // console.log('Config.WEBSOCKET_URL', Config.WEBSOCKET_URL);

    socket.connect();

    socket.on("connect", () => {
      console.log("connected --------------- socket ---------------");
    });

    socket.on("connect_error", (err: any) => {
      console.log(err.message);
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    socket.on("msg", async (msg: any) => {
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({ msg: JSON.stringify(msg) })
      );

      if (msg) {
        try {
          let oParsed = JSON.parse(msg);
          taskQueue.enqueueTask(() => processMsg(oParsed, socket));
        } catch (err) {
          console.log(err);
          console.log(msg);
        }
      }
    });
  };

  React.useEffect(() => {
    if (qrAuth.refresh_token !== "") {
      setTimeout(() => {
        startSocket();
      }, 5000);
    }
  }, [qrAuth]);

  return <></>;
});

export default SocketService;
